import React, { createContext, useContext, useState } from 'react';
import createFetchClient from "openapi-fetch";
import type { paths } from '@/api/v1';
import type { Middleware } from 'openapi-fetch';
import createClient from 'openapi-react-query';
import type { OpenapiQueryClient } from 'openapi-react-query';
import { SentryMiddleware } from '@/api/middleware/sentry-middleware';

type MusioApiContextType = {
  musioApi: OpenapiQueryClient<paths>;
  useMiddleware: (middleware: Middleware) => void;
  ejectMiddleware: (middleware: Middleware) => void;
}

const MusioApiContext = createContext<MusioApiContextType | null>(null);
const musioFetchClient = createFetchClient<paths>({ baseUrl: import.meta.env.VITE_API_URL });
const BOOTSTRAP_MW = [SentryMiddleware];

BOOTSTRAP_MW.forEach((mw) => musioFetchClient.use(mw));

export function MusioClientProvider({ children }: { children: React.ReactNode }) {
  const [musioApi, setMusioApi] = useState(createClient(musioFetchClient));

  const useMiddleware = (middleware: Middleware) => {
    musioFetchClient.use(middleware);
    setMusioApi(createClient(musioFetchClient));
  };

  const ejectMiddleware = (middleware: Middleware) => {
    musioFetchClient.eject(middleware);
    setMusioApi(createClient(musioFetchClient));
  };

  return (
    <MusioApiContext.Provider value={{ musioApi, useMiddleware, ejectMiddleware }}>
      {children}
    </MusioApiContext.Provider>
  );
}

const useMusioApi = () => {
  const client = useContext(MusioApiContext);
  // TODO store this error for better checking 
  if (!client) {
    throw new Error("Musio client context returned null");
  }

  return client;
}

export default useMusioApi;
